<dashboard-loader *ngIf="loadingSelectedStudy$ | async" [title]="'Loading Study...'"></dashboard-loader>
<div
  *ngIf="selectedStudyLoaded$ | async"
  class="dashboard-study-home"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <div *ngIf="selectedStudy$ | async as selectedStudy">
    <div *ngFor="let translation of selectedStudy?.translations">
      <div
        class="dashboard-study-home__title"
        *ngIf="
          translation.language === (selectedLanguage$ | async)?.code && translation.identifier === studyTitleIdentifier
        "
      >
        {{ translation?.translation }}
      </div>
      <div
        class="dashboard-study-home__subtitle"
        *ngIf="
          translation.language === (selectedLanguage$ | async)?.code &&
          translation.identifier === studyDescriptionIdentifier
        "
      >
        {{ translation?.translation }}
      </div>
    </div>
    <div class="dashboard-study-home__status" fxLayout="column">
      <label class="dashboard-study-home__status-label">Status</label>
      <div fxLayout="row">{{ selectedStudy?.status }}</div>
    </div>
    <div *ngIf="interventions?.length > 0" class="dashboard-study-home__interventions">
      <div *ngIf="selectedStudy?.type !== StudyType.CC">
        <mat-card class="dashboard-modules__left-scroll-module-card" style="width: 50%">
          <ng-container>
            <mat-card-header>
              <mat-card-title class="dashboard-modules__left-scroll-module-card-title">
                Enrolment Codes
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="dashboard-modules__left-scroll-module-card-content">
              <div fxLayout="row">
                These voucher and QR-codes are enrolment codes. Share these codes with participants, such that they can
                enrol for your study.
              </div>
              <div fxLayout="row">
                <div fxLayout="column" style="width: 50%; text-align: center">
                  <h1 style="margin-top: 5rem">VOUCHER CODE</h1>
                  <p style="margin-top: 2rem; font-size: 30px">{{ getStudyHash(selectedStudy) }}</p>
                </div>
                <qrcode
                  id="qrcode"
                  [qrdata]="getStudyHash(selectedStudy)"
                  elementType="img"
                  [width]="256"
                  [errorCorrectionLevel]="'M'"
                >
                </qrcode>
              </div>
            </mat-card-content>
            <mat-divider [inset]="true"></mat-divider>
            <mat-card-actions
              class="dashboard-modules__left-scroll-module-card-actions"
              fxLayout="row"
              fxLayoutAlign="end center"
            >
              <button mat-button color="primary" (click)="saveAsImage('qrcode')">Download QR Code as Image</button>
            </mat-card-actions>
          </ng-container>
        </mat-card>
      </div>
      <div *ngIf="selectedStudy?.type === StudyType.CC" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="dashboard-study-home__interventions-title">Links to Questionnaires</div>
      </div>
      <div *ngIf="selectedStudy?.type === StudyType.CC" fxLayout="row wrap">
        <mat-card
          class="dashboard-study-home__interventions-card"
          *ngFor="let url of getUrls(selectedStudy)"
          fxLayout="column"
          fxFlex="30"
        >
          <ng-container>
            <mat-card-header>
              <mat-card-title class="dashboard-study-home__interventions-card-title">
                {{
                  url?.intervention.name.length > interventionTitleLimitation
                    ? (url?.intervention.name | slice: 0:interventionTitleLimitation) + '...'
                    : url?.intervention.name
                }}
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="dashboard-study-home__interventions-card-content">
              <label class="dashboard-study-home__url-label">{{ url?.label }}</label>
              <a class="dashboard-study-home__interventions-card-links" [attr.href]="url?.url" target="_blank">{{
                url?.url
              }}</a>
            </mat-card-content>
          </ng-container>
        </mat-card>
      </div>
    </div>
    <div
      class="dashboard-study-home__interventions"
      *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.VIEW)"
    >
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="dashboard-study-home__interventions-title">Interventions</div>
      </div>
      <div *ngIf="(interventions$ | async)?.length === 0">
        <div>There are no interventions in this study</div>
        <button mat-button color="primary" (click)="createFirstIntervention()">
          {{ 'Create the first intervention' | uppercase }}
        </button>
      </div>
      <div *ngIf="interventions$ | async as interventions" fxLayout="row wrap">
        <mat-card
          *ngFor="let intervention of interventions"
          class="dashboard-study-home__interventions-card"
          fxLayout="column"
          fxFlex="30"
        >
          <mat-card-header>
            <mat-card-title class="dashboard-study-home__interventions-card-title">
              {{
                intervention?.name.length > interventionTitleLimitation
                  ? (intervention?.name | slice: 0:interventionTitleLimitation) + '...'
                  : intervention?.name
              }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="dashboard-study-home__interventions-card-content">
            <div class="dashboard-study-home__interventions-card-content-url">
              <label class="dashboard-study-home__interventions-card-content-url-label">{{
                intervention.url ? intervention.url?.label : 'Preview URL'
              }}</label>
              <a
                *ngIf="selectedStudy?.type === StudyType.CC"
                class="dashboard-study-home__interventions-card-links"
                [attr.href]="careerUrl + '/#/' + intervention?.hash + '/preview'"
                target="_blank"
              >
                {{ careerUrl + '/#/' + intervention?.hash + '/preview' }}
              </a>
              <a
                *ngIf="selectedStudy?.type === StudyType.TIIM"
                class="dashboard-study-home__interventions-card-links"
                [attr.href]="appUrl + '/preview/' + selectedStudy?.hash + '/' + intervention?.id"
                target="_blank"
              >
                {{ appUrl + '/preview/' + selectedStudy?.hash + '/' + intervention?.id }}
              </a>
            </div>
            <div class="dashboard-study-home__interventions-card-text">
              {{
                intervention?.description.length > interventionDescriptionLimitation
                  ? (intervention?.description | slice: 0:interventionDescriptionLimitation) + '...'
                  : intervention?.description
              }}
            </div>
            <mat-divider [inset]="true"></mat-divider>
            <div class="dashboard-study-home__interventions-card-content-statistics">
              <div class="dashboard-study-home__interventions-card-content-statistics-title">Statistics</div>
              <div class="dashboard-study-home__interventions-card-content-statistics-data">
                <label class="dashboard-study-home__interventions-card-content-statistics-data-label">
                  Number of participants
                </label>
                <strong *ngIf="notSociometry">
                  {{ getStatistic(intervention, deviceCount) }}
                </strong>
                <ng-template #notSociometry>
                  <strong>{{ getStatistic(intervention, participantCount) }}</strong>
                </ng-template>
              </div>
              <div class="dashboard-study-home__interventions-card-content-statistics-data">
                <label class="dashboard-study-home__interventions-card-content-statistics-data-label">
                  Number of modules
                </label>
                <strong>{{ getStatistic(intervention, modulesCount) }}</strong>
              </div>
              <div class="dashboard-study-home__interventions-card-progress">
                <div class="dashboard-study-home__interventions-card-text">
                  Overall progress {{ getInterventionProgress(intervention) }}%
                </div>
                <mat-progress-bar color="accent" [value]="getInterventionProgress(intervention)"></mat-progress-bar>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
